export const SocialInboxDirectMessagesSkeleton = () => {
    return (
        <div className="flex h-full min-h-0 flex-1 flex-col overflow-y-auto px-10 pb-10">
            <div className="mt-auto flex animate-pulse flex-col justify-end gap-10">
                {/* Sender message */}
                <div className="relative mr-auto flex w-full max-w-[80%] flex-col">
                    <div className="relative flex flex-row items-end gap-2">
                        <div className="h-10 w-10 rounded-full bg-gray-200 dark:bg-gray-700"></div>
                        <div className="relative flex min-w-24 flex-col gap-2">
                            <div className="flex w-full items-center gap-1">
                                <div className="h-3 w-24 rounded bg-gray-200 dark:bg-gray-700"></div>
                            </div>
                            <div className="flex max-w-full flex-col space-y-1 rounded-2xl bg-gray-200 p-4 dark:bg-gray-700">
                                <div className="h-4 w-32 rounded bg-gray-300 dark:bg-gray-600"></div>
                                <div className="h-3 w-3/4 rounded bg-gray-300 dark:bg-gray-600"></div>
                                <div className="h-3 w-1/2 rounded bg-gray-300 dark:bg-gray-600"></div>
                            </div>
                        </div>
                    </div>
                </div>

                {/* User message */}
                <div className="relative ml-auto flex w-full max-w-[80%] flex-col gap-2">
                    <div className="relative flex flex-row-reverse items-end gap-2">
                        <div className="h-10 w-10 rounded-full bg-gray-200 dark:bg-gray-700"></div>
                        <div className="relative flex min-w-24 flex-col gap-2">
                            <div className="flex w-full items-center justify-end gap-1">
                                <div className="h-3 w-24 rounded bg-gray-200 dark:bg-gray-700"></div>
                            </div>
                            <div className="flex max-w-full flex-col space-y-1 rounded-2xl bg-blue-500 p-4">
                                <div className="h-3 w-3/4 rounded bg-blue-400"></div>
                                <div className="h-3 w-1/2 rounded bg-blue-400"></div>
                            </div>
                        </div>
                    </div>
                </div>
            </div>
        </div>
    );
};
